export const SET_YEAR = 'SET_YEAR'
export const SET_MONTH = 'SET_MONTH'

// localstorage

export const LOCAL_YEAR = 'LOCAL_YEAR'
export const LOCAL_MONTH = 'LOCAL_MONTH'


